export const RESTAURANT_ID = "810e5b7b-a9b4-4cd6-8092-6ddbb22d8a19";

export const S3_IMAGE_BASE_URL = "https://mutfacik.s3.eu-central-1.amazonaws.com/";

// google.com/recaptcha/admin/create adresinden alınan Site Key ile değiştirin.
export const RECAPTCHA_SITE_KEY = "6Lck3LgtAAAAAOITtW1uRWeevN1kMr9B0P6mgFCk";

// v2 checkbox key'inden farklı; google.com/recaptcha/admin/create'te "v3" tipiyle oluşturulmuş key.
export const RECAPTCHA_V3_SITE_KEY = "6Lc6Z8ctAAAAAGFvWqGNUarvJ5lV_NmPuu_poVHA";
